import React, { useEffect, useState } from 'react'
import MySelect from '../../UI/form/MySelect'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { getSupplierContactTypesAllAPI } from '../../../api/supply/supplierContactTypeAPI'

const SupplierContactTypeSelectMain = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
	const [supplierContactTypes, setSupplierContactTypes] = useState([])

	useEffect(() => {
		getSupplierContactTypes()
	}, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getSupplierContactTypes = () => {
		getSupplierContactTypesAllAPI().then(data => {
			setSupplierContactTypes(data)
		}).catch(e => {
			// setError(responseError(e))
			console.error(responseError(e))
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Тип контакту"
        labelId="select__supplierContactType-label"
        id='select__supplierContactType'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Тип контакту'
        // sx={{width: '200px'}}
        options={
			supplierContactTypes && supplierContactTypes.length > 0 ? 
				supplierContactTypes.map(supplierContactType => {
            		return {id: supplierContactType.id, name: supplierContactType.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default SupplierContactTypeSelectMain